<template>
    <div class="apprentice-simple-card create-project">
        <div
            class="row"
            v-if="selectedProjectType === null">
            <div
                class="col-12 col-sm-6 -col-lg-4 col-xl-3 projects-types"
                v-for="(projectType, needle) in projectTypes"
                v-if="typeAvailable(projectType)"
                :key="`option-${needle}`">
                <div
                    class="project-type"
                    @click="selectProjectType(projectType)">
                    <i :class="`icon fad ${projectType.fontClass ? projectType.fontClass : 'fa-book-open'}`"></i>
                    <h5 class="title">{{ projectType.label }}</h5>
                    <div class="description">{{ projectType.description }}</div>
                </div>
            </div>
        </div>

        <design-2021-apprentice-paper-type-wizard-component
            v-if="selectedProjectType === 1"
            :courses-in="courses"
            :current-season-id="currentSeasonId"
            :editor-type-setting="editorType"
            :ratings-in="ratingsIn"
            :roadmaps-in="roadmapsIn"
            :seasons-in="seasons"
            :teachers-in="teachersIn">
        </design-2021-apprentice-paper-type-wizard-component>

        <design-2021-apprentice-portfolio-type-wizard-component
            v-if="selectedProjectType === 2"
            :courses-in="courses"
            :current-season-id="currentSeasonId"
            :editor-type-setting="editorType"
            :ratings-in="ratingsIn"
            :roadmaps-in="roadmapsIn"
            :seasons-in="seasons"
            :teachers-in="teachersIn">
        </design-2021-apprentice-portfolio-type-wizard-component>

        <design-2021-apprentice-quest-type-wizard-component
            v-if="selectedProjectType === 3 && $authUser.isAdmin()"
            :courses-in="courses"
            :current-season-id="currentSeasonId"
            :editor-type-setting="editorType"
            :ratings-in="ratingsIn"
            :roadmaps-in="roadmapsIn"
            :seasons-in="seasons"
            :teachers-in="teachersIn">
        </design-2021-apprentice-quest-type-wizard-component>

        <design-2021-apprentice-magazine-type-wizard-component
            v-if="selectedProjectType === 4 && $authUser.isAdmin()"
            :courses-in="courses"
            :current-season-id="currentSeasonId"
            :ratings-in="ratingsIn"
            :roadmaps-in="roadmapsIn"
            :seasons-in="seasons"
            :teachers-in="teachersIn">
        </design-2021-apprentice-magazine-type-wizard-component>

        <!--        <design-2021-apprentice-plus-type-wizard-component :courses-in="courses"-->
        <!--                                                            :seasons-in="seasons"-->
        <!--                                                            :teachers-in="teachersIn"-->
        <!--                                                           :editor-type-setting="editorType"-->
        <!--                                                            v-if="selectedProjectType === 5">-->
        <!--        </design-2021-apprentice-plus-type-wizard-component>-->

        <design-2021-apprentice-internship-type-wizard-component
            v-if="selectedProjectType === 6"
            :courses-in="courses"
            :current-season-id="currentSeasonId"
            :editor-type-setting="editorType"
            :ratings-in="ratingsIn"
            :roadmaps-in="roadmapsIn"
            :seasons-in="seasons"
            :teachers-in="teachersIn">
        </design-2021-apprentice-internship-type-wizard-component>

        <design-2021-apprentice-creathlon-type-wizard-component
            v-if="selectedProjectType === 7"
            :courses-in="courses"
            :current-season-id="currentSeasonId"
            :editor-type-setting="editorType"
            :ratings-in="ratingsIn"
            :roadmaps-in="roadmapsIn"
            :seasons-in="seasons"
            :education-levels-in="educationLevelsIn"
            :teachers-in="teachersIn">
        </design-2021-apprentice-creathlon-type-wizard-component>
    </div>
</template>

<script>
export default {
    name: 'design-2021-group-create-component',
    props: {
        courses: Array,
        currentSeasonId: Number,
        groups: Array,
        seasons: Array,
        schoolSettingsIn: Object,
        projectTypesIn: Array,
        teachersIn: Array,
        roadmapsIn: Array,
        ratingsIn: Array,
        educationLevelsIn: Array,
    },

    data() {
        return {
            selectedProjectType: null,
            projectTypes: this.projectTypesIn.map((projectType) => {
                return {
                    id: projectType.id,
                    label: projectType.name,
                    key: projectType.controller,
                    description: projectType.description,
                    fontClass: projectType.font_class,
                };
            }),
            values: {},
            currentStep: 0,
            previousBtn: false,
            finishBtn: false,
            editorType:
                this.schoolSettingsIn && this.schoolSettingsIn.editor_type !== null
                    ? this.schoolSettingsIn.editor_type
                    : 'sp',
        };
    },

    methods: {
        selectProjectType(projectType) {
            this.selectedProjectType = projectType.id;
        },
        typeAvailable(projectType) {
            if (projectType.id === 5) {
                return false;
            }

            if (this.$authUser.isTeacher() && [3, 4].includes(projectType.id)) {
                return false;
            }

            if (projectType.id === 7 && !!this.educationLevelsIn.length) {
                return true
            }

            if (projectType.id === 6 && !this.schoolSettingsIn.internships) {
                return false;
            }

            return this.$authUser.isAdmin() || this.$authUser.isTeacher();
        },
    },
};
</script>

<style lang="scss">
.projects-types {
    margin-bottom: $grid-gutter-width;
}

.project-type {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    background-color: $secondary-background-color;
    color: $text-muted-color;
    border-radius: $border-radius-content;
    padding: map-get($grid-gutter-spacing, 'twenty-one');
    height: 100%;

    .icon {
        align-self: center;
        font-size: 6rem;
        color: var(--primary);
        margin-bottom: map-get($grid-gutter-spacing, 'twenty-one');
    }

    .title {
        align-self: center;
        color: $text-color;
        margin-bottom: 0;
    }

    .description {
        align-self: center;
        line-height: 1.5;
    }

    &:hover {
        box-shadow: 1px 0 4px $border-color;
        cursor: pointer;
    }
}
</style>
